import { render, staticRenderFns } from "./authenticate-form.vue?vue&type=template&id=65740652&scoped=true&"
import script from "./authenticate-form.vue?vue&type=script&lang=js&"
export * from "./authenticate-form.vue?vue&type=script&lang=js&"
import style0 from "./authenticate-form.vue?vue&type=style&index=0&id=65740652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65740652",
  null
  
)

export default component.exports